import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="xmppacketinfo" id="xmppacketinfo"></a>
    <h1 {...{
      "id": "xmppacketinfo"
    }}>{`XMPPacketInfo`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.2.0
This object is returned by `}<a parentName="p" {...{
        "href": "./XMPFile.md#getpacketinfo"
      }}>{`XMPFile.getpacketinfo`}</a>{`.. The read-only properties describe the XMP packet for the file represented by the `}<a parentName="p" {...{
        "href": "./XMPFile.md"
      }}>{`XMPFile object`}</a>{`.  `}</p>
    <a name="xmppacketinfo-charform" id="xmppacketinfo-charform"></a>
    <h2 {...{
      "id": "charform--number"
    }}>{`charForm : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The character encoding in the packet, one of:                     0 - UTF8                     2 - UTF-16, MSB-first (big-endian)                     3 - UTF-16, LSB-first (little-endian)                     4 - UTF 32, MSB-first (big-endian)                     5 - UTF 32, LSB-first (little-endian)`}</p>
    <a name="xmppacketinfo-length" id="xmppacketinfo-length"></a>
    <h2 {...{
      "id": "length--number"
    }}>{`length : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The length of the packet in bytes.`}</p>
    <a name="xmppacketinfo-offset" id="xmppacketinfo-offset"></a>
    <h2 {...{
      "id": "offset--number"
    }}>{`offset : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The byte-offset from the start of the file where the packet begins.`}</p>
    <a name="xmppacketinfo-packet" id="xmppacketinfo-packet"></a>
    <h2 {...{
      "id": "packet--string"
    }}>{`packet : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The raw packet data.`}</p>
    <a name="xmppacketinfo-padsize" id="xmppacketinfo-padsize"></a>
    <h2 {...{
      "id": "padsize--number"
    }}>{`padSize : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
The packet’s padding size in bytes, 0 if unknown.`}</p>
    <a name="xmppacketinfo-writeable" id="xmppacketinfo-writeable"></a>
    <h2 {...{
      "id": "writeable--boolean"
    }}>{`writeable : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
If true, the packet is writeable.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      